import { render, staticRenderFns } from "./RulerSvg.vue?vue&type=template&id=2d60c056&"
import script from "./RulerSvg.vue?vue&type=script&lang=ts&"
export * from "./RulerSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports